import React from 'react'
import { NavLink, Link, Route } from 'react-router-dom'

export const HomeNavLink = (
				<NavLink
					className="NavLink PageTitle black-type"
					exact
					to="/"
				>
				<strong>Julian Salinas Fotografie</strong>
				</NavLink>)


export const ComNavLink = (
				<NavLink
					activeClassName=" active"
					className="NavLink"

					to="/com"
				>
				Commissioned Works 
				</NavLink>)


export const ArtNavLink = (
				<NavLink
					activeClassName=" active"
					className="NavLink"
					to="/art"
				>
				Art Works 
				</NavLink>)

export const ComLink = (
				<Link
					className="Link"

					to="/com"
				>
				Commissioned Works 
				</Link>)


export const ArtLink = (
				<Link
					className="Link"
					to="/art"
				>
				Art Works 
				</Link>)


export const AboutNavLink = (
				<NavLink
					activeClassName=" active"
					className="NavLink"
					exact
					to="/about"
				>
				About 
				</NavLink>)



export const BackLink = (
		<Route render={({location})=>{
			let path = location.pathname.split('/')
			path.pop()
			const newPath = path.map((p,i,arr)=>{
				  if (arr.length === i + 1) {
					  return p
				  } else {
					  return p + '/'
				  }
				})
			return(
				<Link
					to={newPath.join('')}
					>
					<i className="icon icon-fw icon-Close black-type" />
				</Link>
			)
		}} />
	)







// WEBPACK FOOTER //
// ./src/NavLinks.js